/**
 * 为带有缓存的请求设置数据保持新鲜时间，在该时间内不会重新发起请求
 */
export const DEFAULT_STALE_TIME = 1000 * 60 * 60
